export const newConfigurationBlockFormBuilderConfig = {
	product: {
		path: 'product',
		DataType: 'Array',
		DisplayText: 'Outgoing Events',
		ButtonText: 'Add Event',
		child: [],
		customClass: 'outgoing-events-table',
		required: false,
		UIOptions: {
			ArrayFieldOptions : {
				templateType: 'table',
				TableHeaders: [
					'Event Name	',
					'Post If',
					'Enabled'
				]
			}
		},
		childFormBuilderConfig: {
			eventName: {
				DataType: 'Selector',
				UIControl: 'Dropdown',
				DisplayText: 'eventName',
				Name: 'eventName',
				required: true,
				options: [],
				UIOptions: {
					ShowClearButton: true,
					showLabel: false,
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: any, extraData: any, fieldOptions?: any) => {
					}
				}
			},
			postIf: {
				DataType: 'Selector',
				UIControl: 'Dropdown',
				DisplayText: 'postIf',
				Name: 'postIf',
				required: true,
				options: [],
				UIOptions: {
					ShowClearButton: true,
					showLabel: false,
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: any, extraData: any, fieldOptions?: any) => {
					}
				}
			},
			enabled: {
				DataType: 'Checkbox',
				Name: 'enabled',
				required: false,
				defaultValue: false,
				options: [{label: 'Off', value: false}, {label: 'On', value: true}],
			}
		}
	},
	productHybrid: {
		path: 'productHybrid',
		DataType: 'Array',
		DisplayText: 'Outgoing Events',
		ButtonText: 'Add Event',
		child: [],
		customClass: 'outgoing-events-table',
		required: false,
		UIOptions: {
			ArrayFieldOptions : {
				templateType: 'table',
				TableHeaders: [
					'Event Name	',
					'Post If',
					'Enabled'
				]
			}
		},
		childFormBuilderConfig: {
			eventName: {
				DataType: 'Selector',
				UIControl: 'Dropdown',
				DisplayText: 'eventName',
				Name: 'eventName',
				required: true,
				options: [],
				UIOptions: {
					ShowClearButton: true,
					showLabel: false,
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: any, extraData: any, fieldOptions?: any) => {
					}
				}
			},
			postIf: {
				DataType: 'Selector',
				UIControl: 'Dropdown',
				DisplayText: 'postIf',
				required: true,
				Name: 'postIf',
				options: [],
				UIOptions: {
					ShowClearButton: true,
					showLabel: false,
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: any, extraData: any, fieldOptions?: any) => {
					}
				}
			},
			enabled: {
				DataType: 'Checkbox',
				Name: 'enabled',
				required: false,
				defaultValue: false,
				options: [{label: 'Off', value: false}, {label: 'On', value: true}],
			}
		}
	},
	productNonHybrid: {
		path: 'productNonHybrid',
		DataType: 'Array',
		DisplayText: 'Outgoing Events',
		ButtonText: 'Add Event',
		child: [],
		customClass: 'outgoing-events-table',
		required: false,
		UIOptions: {
			ArrayFieldOptions : {
				templateType: 'table',
				TableHeaders: [
					'Event Name	',
					'Post If',
					'Enabled'
				]
			}
		},
		childFormBuilderConfig: {
			eventName: {
				DataType: 'Selector',
				UIControl: 'Dropdown',
				DisplayText: 'eventName',
				Name: 'eventName',
				options: [],
				required: true,
				UIOptions: {
					ShowClearButton: true,
					showLabel: false,
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: any, extraData: any, fieldOptions?: any) => {
					}
				}
			},
			postIf: {
				DataType: 'Selector',
				UIControl: 'Dropdown',
				DisplayText: 'postIf',
				Name: 'postIf',
				required: true,
				options: [],
				UIOptions: {
					ShowClearButton: true,
					showLabel: false,
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: any, extraData: any, fieldOptions?: any) => {
					}
				}
			},
			enabled: {
				DataType: 'Checkbox',
				Name: 'enabled',
				required: false,
				defaultValue: false,
				options: [{label: 'Off', value: false}, {label: 'On', value: true}],
			}
		}
	},
}
